export default function getLocale() {
  if (!window || !window.navigator) return 'en-US';

  if (window.navigator.languages) {
    return window.navigator.languages[0];
  }

  return window.navigator.userLanguage || window.navigator.language;
}
